import { useState, useEffect, useCallback } from 'react';

interface UseStickyElementHeightProps {
  elementRef: React.RefObject<HTMLElement>;
  parentRef: React.RefObject<HTMLElement>;
  offset?: number;
}

export const useStickyElementHeight = ({
  elementRef,
  parentRef,
  offset = 0,
}: UseStickyElementHeightProps) => {
  const [height, setHeight] = useState(0);

  const updateHeight = useCallback(() => {
    if (!elementRef.current || !parentRef.current) return;

    const containerRect = elementRef.current.getBoundingClientRect();
    const distanceFromTop = containerRect.top;
    const availableHeight = window.innerHeight - distanceFromTop - offset;
    setHeight(availableHeight);
  }, [elementRef, parentRef, offset]);

  useEffect(() => {
    updateHeight();
    window.addEventListener('resize', updateHeight);
    window.addEventListener('scroll', updateHeight);

    return () => {
      window.removeEventListener('resize', updateHeight);
      window.removeEventListener('scroll', updateHeight);
    };
  }, [updateHeight]);

  return height;
};
